var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76.25 76.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442_\u0431\u0435\u0437_\u043D\u0430\u0437\u0432\u0438_10);}.cls-3{fill:#001bb3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0413\\u0440\\u0430\\u0434\\u0456\\u0454\\u043D\\u0442_\\u0431\\u0435\\u0437_\\u043D\\u0430\\u0437\\u0432\\u0438_10",
    x1: 69.23,
    y1: 60.51,
    x2: 22.64,
    y2: 33.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e9e9e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u043B\u043E\u0433\u043E \u0444\u043B\u0435\u0442\u0448\u043E\u0443") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0428\\u0430\\u0440_2",
    "data-name": "\\u0428\\u0430\\u0440 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.25,38.12A38.08,38.08,0,0,1,46.84,75.25a38.51,38.51,0,0,1-8.71,1A38.13,38.13,0,1,1,76.25,38.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.12,47.38A38.2,38.2,0,0,1,46.84,75.25L25.37,54l5.5-6.62-5.5-5.94,6.13-6.63-6.13-5.93,25.5-6.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.38,
    y: 22.25,
    width: 25.5,
    height: 6.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.38,
    y: 34.81,
    width: 15.8,
    height: 6.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 25.38,
    y: 47.38,
    width: 9.63,
    height: 6.63
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoader);
export default __webpack_public_path__ + "static/media/icon_loader.cad68d6683d1c59df92452d7d3c971f0.svg";
export { ForwardRef as ReactComponent };